import React from "react";
import ReactDOM from "react-dom";

const AgentInfoModal = ({ isOpen, onClose, agentInfo }) => {
    if (!isOpen) return null;

    return ReactDOM.createPortal(
        <div className="modal-overlay" onClick={onClose}>
            <div
                className="modal-content"
                onClick={e => e.stopPropagation()}
            >
                <div className="modal-header">
                    <h3>Agent Info</h3>
                    <button className="close-button" onClick={onClose}>✕</button>
                </div>
                <div className="modal-body">
                    {Array.isArray(agentInfo) && agentInfo.length > 0 ? (
                        <table className="notes-table">
                            <thead>
                                <tr>
                                    <th>Agent Code</th>
                                    <th>Agent Name</th>
                                    <th>Agent Email</th>
                                </tr>
                            </thead>
                            <tbody>
                                {agentInfo.map((agent, idx) => (
                                    <tr key={idx}>
                                        <td>{agent.agtCode || "—"}</td>
                                        <td>{agent.displayName || "—"}</td>
                                        <td>{agent.agtEmail || "—"}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (
                        <p>No agent info available for this record.</p>
                    )}
                </div>
            </div>
        </div>,
        document.body
    );
};

export default AgentInfoModal;